import React, { useCallback, useState } from 'react';
import Button from '../shared/button/button';
import Input from '../shared/input/input';
import { classnames } from '../../utils/classnames';
import Cross from '../shared/cross';
import { quotationPostcodeSearchRedirect } from '../../utils/location';

export default function PharmacyFinderWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({
    pharmacyPostcode: '',
  });

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClickClose = () => {
    setIsOpen(false);
  };
  const handleChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const isDisabled = data.pharmacyPostcode.trim();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isDisabled) quotationPostcodeSearchRedirect(data.pharmacyPostcode);
  };

  return (
    <>
      <div className={classnames('hero__fluVaccine', 'blue-theme', 'hero__widget-block', isOpen && 'js-active')}>
        <div className="hero__widget-header" onClick={handleOpen}>
          <svg
            className="hero__prescriptions-icon"
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_802_6667)">
              <path
                d="M3.12969 15.3179L13.6255 4.82947C14.0018 4.45344 14.5128 4.24188 15.0448 4.24188C15.5768 4.24188 16.0878 4.45344 16.4641 4.82947L19.168 7.53146C19.5437 7.90694 19.7554 8.41754 19.7554 8.94919C19.7554 9.48084 19.5437 9.99145 19.1674 10.3675L8.67161 20.8559M1.69784 13.8869L10.1177 22.3008M0.599976 18.3279L5.67582 23.4001M4.51504 16.7024L1.74409 19.4714M7.28626 19.4714L4.5153 22.2404M12.2739 6.18021L15.1113 9.01899M10.3342 8.11849L12.8558 10.6411M8.11748 10.3337L11.206 13.42M6.1778 12.272L10.0993 16.1907M23.4 0.600098L19.4785 4.5188M19.2009 7.56471L19.9181 6.84864C20.1691 6.59777 20.3099 6.25773 20.3099 5.9033C20.3099 5.54887 20.1691 5.20883 19.9181 4.95796L19.0391 4.07963C18.7881 3.82876 18.4478 3.6881 18.0931 3.6881C17.7384 3.6881 17.3982 3.82876 17.1471 4.07963L16.43 4.79625"
                stroke="#1B75BB"
                strokeMiterlimit="10"
              />
            </g>

            <defs>
              <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z" />
              </clipPath>
            </defs>
          </svg>
          <p className="tpg_b2 hero__widget-text">Flu Voucher Pharmacy Finder</p>
        </div>

        <Cross onClick={handleClickClose} />

        <form onSubmit={handleSubmit}>
          <div className="hero__widget-body">
            <Input
              className="flu-vaccine-input"
              label="Postcode"
              name="pharmacyPostcode"
              value={data.pharmacyPostcode}
              onChange={handleChange}
            />
            <Button
              withIcon
              rightIcon={false}
              iconType="search"
              text="Search"
              onClick={handleSubmit}
              disabled={!isDisabled}
            />
          </div>
        </form>
      </div>
    </>
  );
}
